"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToNumber = exports.formatToString = exports.getIncreasedValue = exports.getSubtractedValue = void 0;
const isNaN_1 = __importDefault(require("lodash/isNaN"));
const isNil_1 = __importDefault(require("lodash/isNil"));
/**
 * @param {number} value
 * @param {number | null} [precision]
 * @returns {number}
 */
const withPrecision = (value, precision) => {
    if ((0, isNaN_1.default)(value) || (0, isNil_1.default)(precision)) {
        return value;
    }
    let reminder = value % 1;
    if (reminder < 0) {
        reminder += 1;
    }
    const base = 10 ** (precision || 0);
    // NOTE: We use reminder to account for floating point errors.
    return value - reminder + Math.round(reminder * base) / base;
};
/**
 * @param {object} options
 * @param {number} options.step
 * @param {number | null} [options.max]
 * @param {number | null} [options.min]
 * @param {number | null} [options.precision]
 * @param {number | null} options.value
 * @return {number}
 */
const getSubtractedValue = ({ value, max, min, step, precision }) => {
    /**
     * @param {number} x
     */
    const clean = (x) => {
        return withPrecision((0, isNil_1.default)(min) ? x : Math.max(x, min), precision);
    };
    if ((0, isNil_1.default)(value)) {
        if ((0, isNil_1.default)(max)) {
            return step;
        }
        return clean(max - step);
    }
    if (!(0, isNil_1.default)(max) && value > max) {
        return max;
    }
    return clean(value - step);
};
exports.getSubtractedValue = getSubtractedValue;
/**
 * @param {object} options
 * @param {number} options.step
 * @param {number | null} [options.max]
 * @param {number | null} [options.min]
 * @param {number | null} [options.precision]
 * @param {number | null} options.value
 * @return {number}
 */
const getIncreasedValue = ({ value, max, min, step, precision }) => {
    /**
     * @param {number} x
     */
    const clean = (x) => {
        return withPrecision((0, isNil_1.default)(max) ? x : Math.min(x, max), precision);
    };
    if ((0, isNil_1.default)(value)) {
        if ((0, isNil_1.default)(min)) {
            return step;
        }
        return clean(min + step);
    }
    if (!(0, isNil_1.default)(min) && value < min) {
        return min;
    }
    return clean(value + step);
};
exports.getIncreasedValue = getIncreasedValue;
/**
 * @param {number | string | null | undefined} value
 * @param {number | null} [precision]
 * @returns {string}
 */
const formatToString = (value, precision) => {
    if (typeof value === 'string') {
        return value;
    }
    if ((0, isNil_1.default)(value) || (0, isNaN_1.default)(value)) {
        return '';
    }
    if ((0, isNil_1.default)(precision)) {
        return value.toString();
    }
    return value.toFixed(precision).replace(/^-?0+(\.0+)?$/, '0');
};
exports.formatToString = formatToString;
/**
 * @param {string | null | undefined} value
 * @param {number | null} [precision]
 * @returns {number | null}
 */
const formatToNumber = (value, precision) => {
    if ((0, isNil_1.default)(value) || value === '') {
        return null;
    }
    const number = withPrecision(Number.parseFloat(value), precision);
    if ((0, isNaN_1.default)(number)) {
        return null;
    }
    if (Math.abs(number) === 0) {
        return 0;
    }
    return number;
};
exports.formatToNumber = formatToNumber;
//# sourceMappingURL=helpers.js.map